// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-ElementParallax----element-parallax-module---container---2cyv_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ElementParallax/element-parallax.module.css
// module id = 305
// module chunks = 35783957827783